<template>
    <layout v-cloak>
	   <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @submit.prevent="saveItem">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <MaterialInput :readonly="form.id!=null" type="text" class="city-form-group city-bg" id="input-url" name="url" v-model.trim="form.url" v-validate="{required: true, url: {require_protocol: true }}" :inputClasses="[{'is-invalid': fnHasError('url') }]" :error=" fnFirstError('url')">URL</MaterialInput>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialSelect :disabled="form.id!=null" class="city-form-group city-bg" id="input-ogc_service_id" name="ogc_service_id" label="code" :filterable="true" :options="lists.ogcservices" v-model.trim="form.ogc_service_id" v-validate="'required'" :inputClasses="[{'is-invalid': fnHasError('ogc_service_id') }]" :error=" fnFirstError('ogc_service_id')">Tipo de Serviço</MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect :readonly="readonlyFormItem" class="city-form-group city-bg" id="input-use_proxy" name="use_proxy" label="name" :filterable="true" :options="lists.onoff" :reduce="option => option.code" v-model.trim="form.use_proxy" v-validate="rulesProxy" :inputClasses="[{'is-invalid': fnHasError('use_proxy') }]" :error=" fnFirstError('use_proxy')" :helpText="help.use_proxy">Utilizar Proxy</MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect :readonly="readonlyFormItem" class="city-form-group city-bg" id="input-is_private" name="is_private" label="name" :filterable="true" :options="lists.onoff" :reduce="option => option.code" v-model.trim="form.is_private" v-validate="'required'" :inputClasses="[{'is-invalid': fnHasError('is_private') }]" :error=" fnFirstError('is_private')" :helpText="help.is_private">Privado</MaterialSelect>
                            </div>
                        </div>
                    </div>
                    <div v-if="form.id">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <MaterialInput :readonly="readonlyFormItem" type="text" class="city-form-group city-bg" id="input-title" name="title" v-model.trim="form.title" v-validate="'required|min:3'" :inputClasses="[{'is-invalid': fnHasError('title') }]" :error=" fnFirstError('title')">Título</MaterialInput>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialTextarea
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg mb-0"
                                        id="input-description"
                                        name="description"
                                        v-model.trim="form.description"
                                        :rows="4"
                                        v-validate="''"
                                        :inputClasses="[{'is-invalid': fnHasError('description') }]"
                                        :error="fnFirstError('description')">
                                        Descrição
                                    </MaterialTextarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialTextarea
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg mb-0"
                                        id="input-abstract"
                                        name="abstract"
                                        v-model.trim="form.abstract"
                                        :rows="4"
                                        v-validate="''"
                                        :inputClasses="[{'is-invalid': fnHasError('abstract') }]"
                                        :error="fnFirstError('abstract')">
                                        Abstract
                                    </MaterialTextarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialInput :readonly="readonlyFormItem" type="text" class="city-form-group city-bg" id="input-keywords" name="keywords" v-model.trim="form.keywords" v-validate="" :inputClasses="[{'is-invalid': fnHasError('keywords') }]" :error=" fnFirstError('keywords')">Keywords</MaterialInput>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialInput :readonly="readonlyFormItem" type="text" class="city-form-group city-bg" id="input-username" name="username" v-model.trim="form.username" v-validate="'min:3'" :inputClasses="[{'is-invalid': fnHasError('username') }]" :error=" fnFirstError('username')">Username</MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialInput :readonly="readonlyFormItem" type="password" class="city-form-group city-bg" id="input-password" name="password" v-model.trim="form.password" v-validate="rulesPassword" :inputClasses="[{'is-invalid': fnHasError('password') }]" :error=" fnFirstError('password')">Password</MaterialInput>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`, true)"
                    >
                    </buttons-footer>
                </form>
            </div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin     from './../../mixin';

    export default {
        mixins: [
            GeneralMixin,
        ],
        components: {
        },
    	data() {
      		return {
      			pageID: 'ogc_remote_services',
                pageTitle: 'Item',
                lists: {
                    loaded: false,
                    onoff: [{'id': 1, 'name': 'Sim', 'code': 1}, {'id': 2, 'name': 'Não', 'code': 0}],
                    ogcservices: [],
                },
                form: {
                    id: null,
                    url: null,
                    use_proxy: 0,
                    is_private: 0,
                    ogc_service_id: null,
                    title: null,
                    description: null,
                    abstract: null,
                    keywords: null,
                    username: null,
                    password: null,
                },
                help: {
                    use_proxy: 'Com o valor <b>"Sim"</b>, é possível publicar temas do servidor OGC sem que o mesmo esteja publicado para a internet, e desta forma, "esconde" o endereço no <b>frontend</b> da aplicação.',
                    is_private: 'Com o valor <b>"Sim"</b>, os temas apenas estão acessíveis para utilizadores autenticados.',
                },
      		}
    	},
        computed: {
            rulesPassword() {
                return {
                    required: !!this.form.username,
                    min: 3
                };
            },
            rulesProxy() {
                return {
                    required: true,
                    is: !!this.form.username ? this.lists.onoff[0].code : this.form.use_proxy,
                };
            },
        },
        mounted() {
            this.loadLists();
        },
    	methods: {
            loadLists: function() {
                if (!this.lists.loaded) {
                    this.$http.get(this.url.getOGCServices)
                    .then(res => {
                        this.lists.ogcservices = res.data.data;
                        this.lists.loaded = true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                    });
                }
            },
    	}
  	}
</script>

<style scoped lang="scss">

</style>

